define('app/factories/lazy_single_factory',['app/setup', 'app/views/lazy_single_view'], function(takhfifan, lazyView) {
  $(function($) {
    if ($('img.lazy-img').length > 0) {
      $('img.lazy-img').each(function() {
        new takhfifan.LazySingleView({
          el: $(this)
        });
      });
    }
  });
});

